import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from '@angular/material/icon';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AccountState } from 'src/app/core/account/state/account.state';
import { filter, take } from 'rxjs';
import { DsButtonComponent } from "src/app/ui/design-system/button/button.component";
import { DsModalShellComponent } from "src/app/ui/design-system/modal-shell/modal-shell.component";

@Component({
  selector: 'app-private-profile-modal',
  standalone: true,
  imports: [
    DsModalShellComponent,
    DsButtonComponent,
    CommonModule,
    MatIconModule,
    TranslateModule],
  templateUrl: './private-profile-modal.component.html',
  styleUrl: './private-profile-modal.component.scss'})
export class PrivateProfileModalComponent {
  constructor(
    private dialogRef: MatDialogRef<PrivateProfileModalComponent>,
    private router: Router,
    private store: Store,
  ) {}

  goToProfile(): void {
    this.dialogRef.close();

    const streamer = this.store.selectSnapshot(AccountState.streamer);
    const editProfilePath = streamer?.atname
      ? `/${streamer.atname}/edit`
      : '/account/profile';

    this.router.navigate([editProfilePath]).then(() => {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => {
          setTimeout(() => {
            const element = document.querySelector('#public-toggle-anchor');
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'});
            }
          }, 300);
        });
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
